import React from 'react';
import { useLocation } from 'react-router-dom';
import ClearIcon from '@mui/icons-material/Clear';
import { accessDeniedDefault } from '../../constants/accessDeniedMessages';
import './AccessDenied.css';

const AccessDenied = () => 
    {
        const routerLocation = useLocation();
        console.log('AccessDenied.jsx: Will display Access Denied.');

        return (<div className="container-error">
            <div className="container-error body">
                <div className="error-icon"><ClearIcon/></div>
                <div className="error-title"><h3>Access Denied</h3></div>
                <div className="error-body">{routerLocation.state ? routerLocation.state.message : accessDeniedDefault}</div>
            </div>
        </div>);
    }

export default AccessDenied;
